import { Toaster } from '@/components/ui/sonner';

import { useTheme } from '@/providers';

export const ThemedToaster = () => {
  const { theme } = useTheme();

  return <Toaster theme={theme} />;
};
